import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace AssociateAgentValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const SubscriptionRecord = defineValidation(BaseRecordSchema);

    export const InvoiceRecord = defineValidation(BaseRecordSchema);

    export const SettlementRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            agentId: baseVals.string(),
            outstandingLimit: baseVals.intMin(50_000, "Limit Tunggakan"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            agent: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    outstandingLimit: baseVals.intMin(50_000, "Limit Tunggakan"),
                }),
            ),
        }),
    );
}
